import React, { useEffect, useRef } from "react";
import "./detail.scss";
const StreamingPlayer = ({ id, category, season = 1, episode = 1 }) => {
  const iframeRef = useRef(null);

  useEffect(() => {
    const height = (iframeRef.current.offsetWidth * 9) / 16 + "px";
    iframeRef.current.setAttribute("height", height);
  }, []);

  const embedUrl =
    category === "tv"
      ? `https://player.videasy.net/tv/${id}/${season}/${episode}`
      : `https://player.videasy.net/movie/${id}`;

  return (
    <div className="streaming-player">
      <iframe
        ref={iframeRef}
        src={embedUrl}
        width="100%"
        allowFullScreen
        title="stream_player"
      ></iframe>
    </div>
  );
};

export default StreamingPlayer;
